import { HostId } from './host-id.enum';

// mapping of url to <hostId>.settings.ts; we check for window.location.host, therefore no trailing slashes
export const hostPatterns: { hostId: HostId; regExp: RegExp[] }[] = [
  {
    hostId: HostId.PreProd,
    regExp: [
      // standalone pprod (e.g. https://owcc-pprod.int.cf.oneweb.mercedes-benz.com/owcc/doorway)
      /^owcc-fe-preprod\.owcc-nonprod\.nprd\.euc1.caas\.oneweb\.mercedes-benz\.com\//,

      // integrated pprod  build on AEM publisher/author (e.g.
      // https://germany.pprod-publish.mbmxp.aem.oneweb.mercedes-benz.com/passengercars/content-pool/tool-pages/car-configurator.html/doorway)
      /pprod-publish([^/])+mercedes-benz\.com/,
      /pprod-author([^/])+mercedes-benz\.com/,

      // preprod for China (e.g. https://www.oneweb-stage.mercedes-benz.com.cn/car-configurator.html/doorway)
      /oneweb-stage\.mercedes-benz\.com\.cn/
    ]
  },
  {
    hostId: HostId.Int,
    regExp: [
      // integrated develop build on AEM publisher/author (e.g.
      // https://germany.int-publish.mbmxp.aem.oneweb.mercedes-benz.com/passengercars/content-pool/tool-pages/car-configurator.html/doorway)
      /int-publish([^/])+mercedes-benz\.com/,
      /int-author([^/])+mercedes-benz\.com/,

      // int for China  (e.g.
      // https://www.oneweb-uat.mercedes-benz.com.cn/car-configurator.html/doorway)
      /oneweb-uat\.mercedes-benz\.com\.cn/
    ]
  },
  {
    hostId: HostId.Test,
    regExp: [
      // feature branch builds
      /^owcc-fe-feature-[^.]+\.owcc-nonprod\.nprd\.euc1.caas\.oneweb\.mercedes-benz\.com\//,

      // integrated test build on AEM publisher/author (e.g.
      // https://germany.int-publish.mbmxp.aem.oneweb.mercedes-benz.com/passengercars/content-pool/tool-pages/car-configurator.html/doorway)
      /test-publish([^/])+mercedes-benz\.com/,
      /test-author([^/])+mercedes-benz\.com/,

      // test for China (e.g. https://www.oneweb-test.mercedes-benz.com.cn/car-configurator.html/doorway)
      /oneweb-test\.mercedes-benz\.com\.cn/
    ]
  },
  {
    hostId: HostId.Dev,
    regExp: [
      // develop in China (e.g. https://www.oneweb-dev.mercedes-benz.com.cn/car-configurator.html/doorway)
      /oneweb-dev\.mercedes-benz\.com\.cn/
    ]
  },
  {
    hostId: HostId.Local,
    regExp: [/^(localhost)|(127.0.0.1)|(0.0.0.0)$/]
  },
  {
    hostId: HostId.TimeTravel,
    regExp: [/(^.*cc-secure\..*)/, /^.*timetravel\..*/]
  },
  {
    hostId: HostId.Expert,
    regExp: [/cc-backend-expert/]
  },
  {
    hostId: HostId.CustomBackend,
    regExp: [
      /configurator\.mercedes-benz\.com\/integration/,
      /cc-int1\.app\.corpintra\.net/,
      /owcc-backend-[^.]+\.owcc-nonprod\.nprd\.euc1\.caas\.oneweb\.mercedes-benz.com/,
      /owcc-backend-ccs-int\.owcc-prod\.prd\.euc1\.caas\.oneweb\.mercedes-benz.com/,
      /owcc-backend-pmd-int\.owcc-prod\.prd\.euc1\.caas\.oneweb\.mercedes-benz.com/,
      /owcc-backend\.owcc-nonprod\.nprd\.euc1\.caas\.oneweb\.mercedes-benz.com/,
      /[^.]+\.owcc\.corpinter\.net/,
      /[^.]+\.[^.]+\.owcc\.corpinter\.net/
    ]
  },
  {
    hostId: HostId.Prod,
    regExp: [
      // all public AEM urls (cached) (e.g. https://www.mercedes-benz.de/passengercars/mercedes-benz-cars/car-configurator.html/doorway)
      /^www\.mercedes-benz\./,
      /^www2\.mercedes-benz\./,
      /^www\.([a-z-]+\.)?mercedes-benz-mena\./,

      // configurator standalone (cached) (e.g. https://configurator.mercedes-benz.com/owcc/doorway)
      /^configurator\.mercedes-benz\.com\//,

      // configurator standalone (uncached) (e.g. https://owcc-main.prod.cf.oneweb.mercedes-benz.com/owcc/doorway)
      /^owcc-fe-prod\.owcc-prod\.prod\.euc1.caas\.oneweb\.mercedes-benz\.com\//,

      // AEM publisher (uncached) (e.g.
      // https://germany.prod-publish.mbmxp.aem.oneweb.mercedes-benz.com/passengercars/content-pool/tool-pages/car-configurator.html/doorway)
      /^[a-z-]+\.prod-publish[^/]+mercedes-benz\./
    ]
  }
];
